import toastr from 'toastr'

toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "10000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

export function showMessage(titulo, message, tipo) {
    toastr[tipo](message, titulo)
}

export function messageError(message) {
    showMessage('Erro', message, 'error')
}

export function messageSuccess(message) {
    showMessage('', message, 'success')
}

export function messageAlert(message) {
    showMessage('Atenção', message, 'warning')
}

export function messageInfo(message) {
    showMessage('', message, 'info')
}